module.exports = __webpack_public_path__ + "static/TemporaryImageEliteBuilder-cb6d5ddfdd63aca1bbed7b782638f724.jpg";